var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar',{attrs:{"site":_vm.site}}),_c('div',[_c('router-view'),_c('footerView',{attrs:{"site":_vm.site}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }